export enum VisaType {
    Study,
	Work,
	Permanent
}